import React from 'react'
import { Box } from '@mui/system'
import VideoPlayer from '../../../../components/videoPlayer'
import { Body1, H4 } from '../../../../layouts/TextStyles'
import { SectionDetailsState } from '../../../../features/types'

interface Props {
    videoDetails: SectionDetailsState
    videoLessonId: number
}

const VideoContent: React.FC<Props> = ({ videoDetails }) => {
    const link = new URL(videoDetails.link).pathname.substring(1)

    return (
        <Box>
            <VideoPlayer link={link} />

            <Box>
                <H4>{videoDetails.title}</H4>
            </Box>

            <Box>
                <Body1>{videoDetails.description}</Body1>
            </Box>
        </Box>
    )
}

export default VideoContent
